import React, { useState, useCallback, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Directory from "../../../services/Directory";

const SimpleCategoryModal = ({ onClose, onCategoryAdded, initialName = '' }) => {
  const [name, setName] = useState(initialName);
  const [value, setValue] = useState('');
  const [errorTitle, setErrorTitle] = useState();
  const [successView, setSuccessView] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isTranslating, setIsTranslating] = useState(false);

  const translateText = useCallback(async (text, targetLang = 'en') => {
    if (!text.trim()) return '';

    try {
      const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=${targetLang}&dt=t&q=${encodeURIComponent(text)}`;

      const response = await fetch(url);
      const result = await response.json();

      if (result && result[0] && result[0][0] && result[0][0][0]) {
        return result[0][0][0].replace(/\s+/g, '_').toLowerCase();
      }

      throw new Error('Translation failed');
    } catch (error) {
      console.error('Translation error:', error);
      return transliterate(text);
    }
  }, []);

  const transliterate = (text) => {
    const translitMap = {
      'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo',
      'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm',
      'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
      'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch', 'ш': 'sh', 'щ': 'sch', 'ъ': '',
      'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu', 'я': 'ya',
      'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'Yo',
      'Ж': 'Zh', 'З': 'Z', 'И': 'I', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M',
      'Н': 'N', 'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
      'Ф': 'F', 'Х': 'H', 'Ц': 'C', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Sch', 'Ъ': '',
      'Ы': 'Y', 'Ь': '', 'Э': 'E', 'Ю': 'Yu', 'Я': 'Ya'
    };

    return text.split('').map(char => translitMap[char] || char).join('')
      .replace(/\s+/g, '_').toLowerCase();
  };

  useEffect(() => {
    if (initialName.trim()) {
      setIsTranslating(true);
      translateText(initialName.trim())
        .then(translated => {
          setValue(translated);
        })
        .catch(error => {
          console.error('Auto-translation failed:', error);
          setValue(transliterate(initialName.trim()));
        })
        .finally(() => {
          setIsTranslating(false);
        });
    }
  }, [initialName, translateText]);

  const handleNameChange = async (e) => {
    const newName = e.target.value;
    setName(newName);

    if (newName.trim()) {
      setIsTranslating(true);
      try {
        const translated = await translateText(newName.trim());
        setValue(translated);
      } catch (error) {
        console.error('Auto-translation failed:', error);
      } finally {
        setIsTranslating(false);
      }
    } else {
      setValue('');
    }
  };

  const onSubmit = () => {
    if (name.trim()) {
      setErrorTitle();
      setIsSubmitting(true);

      Directory.addPrivateCategory({ name: name.trim(), value: value || transliterate(name.trim()) })
        .then(response => {
          if (response.status === 200) {
            setSuccessView(true);
            if (onCategoryAdded) {
              onCategoryAdded(response.data);
            }
          } else {
            setErrorTitle('Произошла ошибка, попробуйте позже');
            setIsSubmitting(false);
          }
        })
        .catch(error => {
          console.log(error);
          setErrorTitle('Произошла ошибка, попробуйте позже');
          setIsSubmitting(false);
        });
    } else {
      setErrorTitle('Необходимо заполнить название категории');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isSubmitting && !isTranslating) {
      onSubmit();
    }
  };

  const renderContent = () => {
    if (successView) {
      return (
        <div style={{ textAlign: 'center', padding: '32px' }}>
          <div>
            <div style={{
              display: 'inline-block',
              backgroundColor: 'rgba(19, 182, 94, 0.1)',
              width: '80px',
              height: '80px',
              borderRadius: '50%'
            }}>
              <div style={{ height: '20px', marginTop: '28px' }}>
                <img src="/icons/tick-success.svg" height="22px" alt="Success" />
              </div>
            </div>
          </div>
          <div style={{ fontSize: '20px', fontWeight: '700', marginTop: '16px' }}>
            Категория успешно добавлена!
          </div>
          <div style={{
            fontSize: '15px',
            marginTop: '4px',
            textAlign: 'center',
            color: '#A3ACB6',
            padding: '0 32px'
          }}>
            Теперь данная категория доступна при создании заказа
          </div>
          <div style={{ marginTop: '20px' }}>
            <Button onClick={onClose} size="sm" variant="primary">
              Закрыть
            </Button>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ padding: '24px' }}>
          <Form.Group className="mb-3">
            <Form.Label style={{ color: '#A3ACB6', fontSize: '15px' }}>
              Название категории
            </Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={handleNameChange}
              onKeyPress={handleKeyPress}
              placeholder="Введите название категории"
              autoFocus
              disabled={isSubmitting}
            />
          </Form.Group>

          <input type="hidden" value={value} />

          {errorTitle && (
            <div style={{ color: 'red', fontSize: '14px', marginBottom: '16px' }}>
              {errorTitle}
            </div>
          )}

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
            <Button
              onClick={onClose}
              variant="secondary"
              disabled={isSubmitting}
            >
              Отменить
            </Button>
            <Button
              onClick={onSubmit}
              variant="success"
              disabled={isSubmitting || !name.trim() || isTranslating}
            >
              {isSubmitting ? isTranslating : 'Добавить'}
            </Button>
          </div>
        </div>
      );
    }
  };

  return (
    <div className='modal-overlay'>
      <div style={{
        backgroundColor: '#ffffff',
        maxHeight: 'calc(100vh - 50px)',
        width: '400px',
        margin: '24px auto',
        borderRadius: '6px'
      }}>
        <div style={{
          padding: '14px 24px',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#ffffff',
          justifyContent: 'space-between',
          borderBottom: '1px solid #eeeeee',
          borderTopLeftRadius: '6px',
          borderTopRightRadius: '6px'
        }}>
          <div style={{ fontSize: '16px', backgroundColor: '#ffffff', fontWeight: '600' }}>
            Добавить категорию
          </div>
          <div
            style={{ cursor: 'pointer', fontSize: '18px', color: '#999' }}
            onClick={onClose}
          >
            ×
          </div>
        </div>
        <div style={{ overflowY: 'scroll', maxHeight: 'calc(100vh - 103px)', textAlign: 'left' }}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default SimpleCategoryModal;